import React from 'react';
import PropTypes from 'prop-types';
import FormUploadAvatar from '../../form/FormUploadAvatar';
import { getRecordData } from '../../../utils/tools';
import { RestInputContext } from '../RestInputContext';

const RestAvatarInput = (props) => (
  <RestInputContext.Consumer>
    {({ record, form }) => (
      <FormUploadAvatar
        {...props}
        record={record}
        form={form}
        defaultValue={getRecordData(record, props.source)}
      />
    )}
  </RestInputContext.Consumer>
);

RestAvatarInput.propTypes = {
  source: PropTypes.string,
  record: PropTypes.object,
};

export default RestAvatarInput;
